import { render } from "./SelectedPlanInfoMob.vue?vue&type=template&id=574ef870"
import script from "./SelectedPlanInfoMob.vue?vue&type=script&lang=js"
export * from "./SelectedPlanInfoMob.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__